// This was taken from the /market implementation of a market timeseries
// TODO: this logic should reside on the BE
function calculateDiffPercentage(num: number, per: number) {
  if (per !== 0) {
    return ((num - per) / Math.abs(per)) * 1;
  }
  return 0;
}

export const normaliseData = (
  data?: Record<string, number>
): [Date, number][] => {
  if (typeof data === 'undefined') return [];
  return Object.entries(data || {}).map(([date, value]) => {
    return [new Date(date), value];
  });
};

export const normaliseDataWithPercentageDiff = (
  data?: Record<string, number>
): [Date, number][] => {
  const normalisedData = normaliseData(data);
  let marketCap = 0;
  return normalisedData.map(([date, value], i) => {
    marketCap = i === 0 || marketCap === 0 ? value : marketCap;
    return [date, calculateDiffPercentage(value, marketCap)];
  });
};
